if (!customElements.get('announcement-dropdown')) {
    customElements.define(
      'announcement-dropdown',
      class AccountButton extends HTMLElement {
        constructor() {
            super();
            
            this.details = this.querySelector('details');
            if(this.details) {
                document.addEventListener('click', (e) => {
                if(!this.details.contains(e.target)) {
                    this.details.removeAttribute("open")
                }
                });
            }
        }
      }
    );
  }
  